// extracted by mini-css-extract-plugin
export default {"Page":"Page_Page__18Qcd","ContentContainer":"Page_ContentContainer__dun5k","Main":"Page_Main__wceSS"};